import type { StepData } from "Components/Shared/Stepper/types";

export const canStepBeActivated = <TStepId extends string>(
  steps: ReadonlyArray<StepData<TStepId>>,
  stepIndex: number,
) => {
  const isFirstStep = stepIndex === 0;
  const isCompleted = steps[stepIndex]?.isCompleted;
  const isOneAfterCompletedStep = steps[stepIndex - 1]?.isCompleted;
  const isEverythingBeforeStepCompleted = steps
    .slice(0, stepIndex)
    .every((step) => step.isCompleted);

  return (
    isFirstStep ||
    (isEverythingBeforeStepCompleted && isCompleted) ||
    (isEverythingBeforeStepCompleted && isOneAfterCompletedStep)
  );
};

export const getActiveConnectors = <TStepId extends string = string>(
  steps: ReadonlyArray<StepData<TStepId>>,
  activeStepIndex: number,
) => {
  const activeConnectors = steps.map((_, i) => {
    if (i === 0) return false;

    const isAllPreviousCompleted = steps
      .slice(0, i)
      .every((step) => step.isCompleted);

    const isRightCompleted = steps[i].isCompleted;
    const isRightActive = activeStepIndex === i;

    const isBeyondActiveStep = i > activeStepIndex;

    return (
      isAllPreviousCompleted &&
      (isRightCompleted || isRightActive) &&
      !isBeyondActiveStep
    );
  });

  return activeConnectors;
};
